export function getInvestmentInterpretation(roi) {
  if (roi >= 2) {
    return {
      label: "Highly Efficient",
      color: "text-green-700",
      description:
        "Investment produces strong financial risk reduction relative to cost.",
    };
  }

  if (roi >= 1) {
    return {
      label: "Financially Efficient",
      color: "text-emerald-700",
      description:
        "Investment generates positive expected financial return through exposure reduction.",
    };
  }

  if (roi >= 0.7) {
    return {
      label: "Strategic Risk Reduction",
      color: "text-amber-700",
      description:
        "Investment improves resilience and reduces severe loss exposure, although direct financial return remains limited.",
    };
  }

  return {
    label: "Resilience / Compliance Driven",
    color: "text-red-700",
    description:
      "Investment may be justified by operational resilience, regulatory requirements, or business continuity objectives rather than direct financial return.",
    };
}
